import React from 'react'

type Props = {
  open: boolean
  onClose: () => void
  onSelect: (intent: 'chat' | 'message') => void
  targetUserId: string
  targetUserName: string
  context?: { postId?: string }
  busy?: boolean
}

export default function ContactIntentModal({
  open,
  onClose,
  onSelect,
  targetUserName,
  busy,
}: Props) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-[90] grid place-items-center bg-black/70 p-4" onClick={onClose}>
      <div
        className="w-full max-w-md rounded-2xl border border-white/15 bg-[#0b0b10] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-extrabold">Contact {targetUserName || 'this user'}</h3>
        <p className="mt-1 text-sm text-white/65">Choose how you want to reach out.</p>

        <div className="mt-4 grid gap-3">
          <button
            type="button"
            onClick={() => onSelect('chat')}
            disabled={busy}
            className="w-full rounded-xl border border-sky-400/30 bg-sky-500/10 px-4 py-4 text-left hover:bg-sky-500/20 disabled:opacity-60"
          >
            <div className="text-sm font-semibold text-sky-100">Chat</div>
            <div className="mt-1 text-xs text-sky-100/80">Open real-time DM conversation.</div>
          </button>

          <button
            type="button"
            onClick={() => onSelect('message')}
            disabled={busy}
            className="w-full rounded-xl border border-white/20 bg-white/5 px-4 py-4 text-left hover:bg-white/10 disabled:opacity-60"
          >
            <div className="text-sm font-semibold text-white">Send Message</div>
            <div className="mt-1 text-xs text-white/70">Open compose with recipient pre-filled.</div>
          </button>
        </div>

        <div className="mt-4 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="rounded-lg border border-white/20 bg-white/5 px-3 py-2 text-sm hover:bg-white/10 disabled:opacity-60"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
